import React, { Component } from 'react';
import PropTypes from 'prop-types';

/* Core */
import Modal from '../../core/Modal';
import ShareSend from '../../core/OptionsNews/ShareSend';

/* Utils */
import { sendByEmailAudiences } from '../../../utils/apiSocial';

class ModalEmail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false
    };
  }

  onSendHandler = (emailList, msg) => {
    const { closeModal, pdfUrl, pdfName, xlsName, xlsUrl } = this.props;

    const data = {
      pdfUrl,
      pdfName,
      xlsName,
      xlsUrl,
      emailToSend: emailList,
      recommendationText: msg
    };

    this.setState({ isLoading: true });

    sendByEmailAudiences(data)
      .then(() => {
        closeModal();
      })
      .catch(error => {
        this.setState({ isLoading: false });
        console.error('Error:', error);
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };

  render() {
    const { closeModal } = this.props;
    const { isLoading } = this.state;

    return (
      <Modal clickCloseIcon={closeModal}>
        <ShareSend
          onSend={this.onSendHandler}
          isLoading={isLoading}
          darkTitle
        />
      </Modal>
    );
  }
}

ModalEmail.propTypes = {
  closeModal: PropTypes.func,
  pdfUrl: PropTypes.string,
  pdfName: PropTypes.string,
  xlsUrl: PropTypes.string,
  xlsName: PropTypes.string
};

export default ModalEmail;
